import React from "react";


import {
    NavLink
} from "react-router-dom";

import {
    Row, Col
} from "react-bootstrap";


import {
    SvgIconComponent
} from "@Components/Elements";

import {
    ButtonComponent
} from "@Components/Forms";


import IconArrowLeftSmBrown from "./@Icons/icon-arrow_left-sm-brown.svg";
import IconArrowRightLongSmOrange from "./@Icons/icon-arrow_right_long-sm-orange.svg";
import IconArrowRightSmBrown from "./@Icons/icon-arrow_right-sm-brown.svg";
import IconInfoOutlineSmOrange from "./@Icons/icon-info_outline-xs-orange.svg";
import IconTooltipDashBottomXsBrown from "./@Icons/icon-tooltip_dash_bottom-xs-brown.svg";

import Step1Image from "./@Images/step1.svg";
import Step2Image from "./@Images/step2.svg";
import Step3Image from "./@Images/step3.svg";
import Step4Image from "./@Images/step4.svg";
import Step5Image from "./@Images/step5.svg";


import "./index.scss";


interface UserDashboardSubmitRequestStartStepComponentProps {
    userSubmitRequestStepSetter: (step: number) => void;
}


export const UserDashboardSubmitRequestStartStepComponent:React.FC<UserDashboardSubmitRequestStartStepComponentProps> = ({
    userSubmitRequestStepSetter
}) => {

    return (
        <Col className={`user-dashboard-submit-request-start-step`}>
            <Row className={`user-dashboard-submit-request-start-step__step-content`}>

                <Col xs={2} lg={12} className={`user-dashboard-submit-request-start-step__back-to-dashboard`}>
                    <NavLink to={`/dashboard`} className={`user-dashboard-submit-request-start-step__back-to-dashboard__back-link`}>
                        <SvgIconComponent iconSource={IconArrowLeftSmBrown} className={`user-dashboard-submit-request-start-step__back-to-dashboard__back-link__link-icon`} />
                        <span className={`user-dashboard-submit-request-start-step__back-to-dashboard__back-link__link-text`}>Back</span>
                    </NavLink>
                </Col>

                <Col xs={10} lg={12} className={`user-dashboard-submit-request-start-step__step-header`}>
                    <span>Start your refund or compensation request.</span>
                </Col>

                <Col xs={12} className={`user-dashboard-submit-request-start-step__step-content`}>
                    <Row className={`user-dashboard-submit-request-start-step__step-content__steps-list`}>

                        <Col xs={12} lg={2} className={'user-dashboard-submit-request-start-step__step-content__step-element odd-step-element'}>
                            <Row className={'user-dashboard-submit-request-start-step__step-content__step-element__step-content'}>
                                <Col xs={2} lg={12} className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image'}>
                                    <img src={Step1Image} alt={''} />
                                    <span className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip'}>
                                        <SvgIconComponent iconSource={IconInfoOutlineSmOrange} className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip__tooltip-icon'} />
                                        <span className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip__tooltip-text'}>
                                            Tell us what went wrong.<br/><br/>
                                            Choose the issue you experienced and what you’d like to recover — we’ll guide the rest.
                                            <SvgIconComponent iconSource={IconTooltipDashBottomXsBrown} className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip__tooltip-text__tooltip-dash'} />
                                        </span>
                                    </span>
                                </Col>
                                <Col xs={10} lg={12} className={'user-dashboard-submit-request-start-step__step-content__step-element__step-title'}>
                                    <span>Pick the refund or compensation</span>
                                </Col>
                                <Col xs={12} className={'user-dashboard-submit-request-start-step__step-content__step-element__step-description'}>
                                    <span>Choose what type of claim you want to submit.</span>
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} lg={'auto'} className={'user-dashboard-submit-request-start-step__step-content__step-separator'}>
                            <SvgIconComponent iconSource={IconArrowRightLongSmOrange} />
                        </Col>

                        <Col xs={12} lg={2} className={'user-dashboard-submit-request-start-step__step-content__step-element even-step-element'}>
                            <Row className={'user-dashboard-submit-request-start-step__step-content__step-element__step-content'}>
                                <Col xs={2} lg={12}
                                     className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image'}>
                                    <img src={Step2Image} alt={''}/>
                                    <span className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip'}>
                                        <SvgIconComponent iconSource={IconInfoOutlineSmOrange} className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip__tooltip-icon'}/>
                                        <span className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip__tooltip-text'}>
                                            Just send what you already have.<br/><br/>
                                            Upload files or forward the airline email. No forms, no manual data entry.
                                            <SvgIconComponent iconSource={IconTooltipDashBottomXsBrown} className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip__tooltip-text__tooltip-dash'}/>
                                        </span>
                                    </span>
                                </Col>
                                <Col xs={10} lg={12}
                                     className={'user-dashboard-submit-request-start-step__step-content__step-element__step-title'}>
                                    <span>Upload or forward documents</span>
                                </Col>
                                <Col xs={12}
                                     className={'user-dashboard-submit-request-start-step__step-content__step-element__step-description'}>
                                    <span>
                                        Add your ticket or booking email to begin.
                                    </span>
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} lg={'auto'}
                             className={'user-dashboard-submit-request-start-step__step-content__step-separator'}>
                            <SvgIconComponent iconSource={IconArrowRightLongSmOrange}/>
                        </Col>

                        <Col xs={12} lg={2}
                             className={'user-dashboard-submit-request-start-step__step-content__step-element odd-step-element'}>
                            <Row className={'user-dashboard-submit-request-start-step__step-content__step-element__step-content'}>
                                <Col xs={2} lg={12}
                                     className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image'}>
                                    <img src={Step3Image} alt={''}/>
                                    <span className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip'}>
                                        <SvgIconComponent iconSource={IconInfoOutlineSmOrange} className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip__tooltip-icon'}/>
                                        <span className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip__tooltip-text'}>
                                            One quick check — make sure the extracted details look right before we move forward.
                                            <SvgIconComponent iconSource={IconTooltipDashBottomXsBrown} className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip__tooltip-text__tooltip-dash'}/>
                                        </span>
                                    </span>
                                </Col>
                                <Col xs={10} lg={12}
                                     className={'user-dashboard-submit-request-start-step__step-content__step-element__step-title'}>
                                    <span>Confirm details</span>
                                </Col>
                                <Col xs={12}
                                     className={'user-dashboard-submit-request-start-step__step-content__step-element__step-description'}>
                                    <span>
                                        Review your flight and personal information.
                                    </span>
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} lg={'auto'}
                             className={'user-dashboard-submit-request-start-step__step-content__step-separator'}>
                        <SvgIconComponent iconSource={IconArrowRightLongSmOrange} />
                        </Col>

                        <Col xs={12} lg={2} className={'user-dashboard-submit-request-start-step__step-content__step-element even-step-element'}>
                            <Row className={'user-dashboard-submit-request-start-step__step-content__step-element__step-content'}>
                                <Col xs={2} lg={12}
                                     className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image'}>
                                    <img src={Step4Image} alt={''}/>
                                    <span className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip'}>
                                        <SvgIconComponent iconSource={IconInfoOutlineSmOrange} className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip__tooltip-icon'}/>
                                        <span className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip__tooltip-text'}>
                                            Claim sent on your behalf.<br/><br/>
                                            We submit everything directly to the airline through the correct channels.
                                            <SvgIconComponent iconSource={IconTooltipDashBottomXsBrown} className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip__tooltip-text__tooltip-dash'}/>
                                        </span>
                                    </span>
                                </Col>
                                <Col xs={10} lg={12}
                                     className={'user-dashboard-submit-request-start-step__step-content__step-element__step-title'}>
                                    <span>Qyvo files your claim</span>
                                </Col>
                                <Col xs={12}
                                     className={'user-dashboard-submit-request-start-step__step-content__step-element__step-description'}>
                                    <span>
                                        We submit your request to the airline for you.
                                    </span>
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} lg={'auto'}
                             className={'user-dashboard-submit-request-start-step__step-content__step-separator'}>
                        <SvgIconComponent iconSource={IconArrowRightLongSmOrange} />
                        </Col>

                        <Col xs={12} lg={2} className={'user-dashboard-submit-request-start-step__step-content__step-element odd-step-element'}>
                            <Row className={'user-dashboard-submit-request-start-step__step-content__step-element__step-content'}>
                                <Col xs={2} lg={12}
                                     className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image'}>
                                    <img src={Step5Image} alt={''}/>
                                    <span className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip'}>
                                        <SvgIconComponent iconSource={IconInfoOutlineSmOrange} className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip__tooltip-icon'}/>
                                        <span className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip__tooltip-text'}>
                                            Watch it unfold.<br/><br/>
                                            See updates as they happen and get notified when the airline responds.
                                            <SvgIconComponent iconSource={IconTooltipDashBottomXsBrown} className={'user-dashboard-submit-request-start-step__step-content__step-element__step-image__step-tooltip__tooltip-text__tooltip-dash'}/>
                                        </span>
                                    </span>
                                </Col>
                                <Col xs={10} lg={12}
                                     className={'user-dashboard-submit-request-start-step__step-content__step-element__step-title'}>
                                    <span>Track your progress</span>
                                </Col>
                                <Col xs={12}
                                     className={'user-dashboard-submit-request-start-step__step-content__step-element__step-description'}>
                                    <span>
                                        Follow your claim status in your dashboard.
                                    </span>
                                </Col>
                            </Row>
                        </Col>

                    </Row>
                </Col>

                <Col xs={12} className={`user-dashboard-submit-request-start-step__go-to-next-step`}>
                <ButtonComponent
                        size={'l'}
                        text={'Let’s start'} iconRight={IconArrowRightSmBrown}
                        callback={() => userSubmitRequestStepSetter(1)}
                    />
                </Col>

            </Row>
        </Col>
    );

};


export default UserDashboardSubmitRequestStartStepComponent;
